// import Swiper bundle with all modules installed
import { auto } from '@popperjs/core';
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';



var swiperPoints = new Swiper(".swiper-points", {
    spaceBetween: 30,

    // autoplay: {
    //     // delay: 3000,
    //     disableOnInteraction: true
    // },   
    grabCursor: true, 
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
    },
    breakpoints: {
        1800: {
            slidesPerView: 3.1,
            spaceBetween: 15,
        },
        1400: {
            slidesPerView: 2.5,
            spaceBetween: 15,
        },
        1024: {
            slidesPerView: 2.2,
            spaceBetween: 15,
        },
        768: {
            slidesPerView: 2.2,
            spaceBetween: 10,
        },
        640: {
            slidesPerView: 2,
            spaceBetween: 10,
        },
        320: {
            slidesPerView: 1,
            spaceBetween: 10,
        },
    },
    on:{
        activeIndexChange(swiper) {
           swiperIndex(swiper);
        },
        init(swiper) {
            swiperIndex(swiper);
        }
    }
    
});


function swiperIndex(swiper){
     console.log(swiper.realIndex);
    //    .swiper-current
    const c = document.querySelector('.swiper-current');
    if(c){
        c.innerHTML = swiper.realIndex + 1;
    }
    // .swiper-total
    const t = document.querySelector('.swiper-total');
    if(t){
        t.innerHTML = swiper.slides.length;
    }
}


